import { render, staticRenderFns } from "./FormShippingCompany.vue?vue&type=template&id=3cddaab9"
import script from "./FormShippingCompany.vue?vue&type=script&lang=js"
export * from "./FormShippingCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports